<template>
<div style="background:white">
<div style="position:relative;margin-top:-20px">
<div class="contact-wrapper">

<div>
    <p class="contact-head">Contact us</p>
    <p stle="text-align:center;">Hey, Need something? Got some doubt in your mind? Reach us for free consultation.</p>
</div>
</div>
</div>

<div class="container">
  <h4 data-aos="fade-in">Get In Touch</h4>
  <br>
</div>
<div class="contact-details" >
       <div class="card" style="width:350px;" >
        <div class="card-image">
          <img src="../assets/contact.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Contact Details</span>
         <p style="font-size:12px;"><i class="material-icons left">my_location</i>H-06/117, Aggarwal Tower, Netaji Subhash Place, Pitampura, New Delhi-110034</p>
         <p style="font-size:12px;"><i class="material-icons left">my_location</i>B-19, East Krishna Nagar, Delhi- 110051</p>
         <p style="font-size:12px;"><i class="material-icons left">my_location</i>Khasra No-79, Near HDFC Bank, Main Market, Kalka Shimla Road (NH5), Dharampur, Distt Solan (HP) 173209</p>
        </div>
      </div>

      <div class="card" style="width:350px" >
        <div class="card-image">
          <img src="../assets/contact.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Contact Details</span>
         <p><i class="material-icons left">email</i>kartikchugh.co@gmail.com</p>
         <p><i class="material-icons left">email</i>cakartikchugh@gmail.com</p>
         <p><i class="material-icons left">email</i>k.chugh@kcco.co.in</p>
        </div>
      </div>

      <div class="card" style="width:350px" >
        <div class="card-image">
          <img src="../assets/contact.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Contact Details</span>
         <p><i class="material-icons left">phone</i>+91-9999-09-8879</p>
         <p><i class="material-icons left">phone</i>+91-11-4587-2080</p>
         <p><i class="material-icons left">phone</i>+91-8468-84-6840</p>
        </div>
      </div>

</div>


</div>
</template>

<script>
export default {
  name: "Contact",
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");

.contact-wrapper{
     background-image: linear-gradient(90deg, rgba( 1, 46, 97, 0.8),  rgba(2, 71, 148, 0.7));
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: white;
    padding: 0px 6%;
    font-family: 'Montserrat', sans-serif;
}
.contact-head{
    margin: 0px;
    font-size: 32px;
    font-weight: 700;
    text-align:center;
}
div{
    font-family: 'Montserrat', sans-serif;
}


.card-title{
  position:relative !important;
  font-weight: 600 !important;
  font-size:18px !important;
}
.card{
  text-align:center;
  margin:20px;
  border:0px;
  box-shadow:0px 0px 0px;
}

.card-content p{
  text-align:center;
  margin-bottom: 10px !important;
}
.contact-details{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
}

h4{
  font-size:24px;
  font-weight:600;
  margin-bottom:20px;
  text-align:center;
}
.card-image img{
  width:64px !important;
  margin:auto !important;
  padding:5px !important;
}

</style>